export const DEFAULT_BREAKS = [30, 60, 90, 120, 150, 180, 365];
const LS_KEY = 'storage_ageing_breaks';

export const loadBreaks = () => {
  try {
    const v = JSON.parse(localStorage.getItem(LS_KEY) || 'null');
    if (Array.isArray(v) && v.length && v.every((n) => Number.isInteger(n) && n > 0)) return v;
  } catch { /* fall through */ }
  return DEFAULT_BREAKS;
};

export const saveBreaks = (b) => localStorage.setItem(LS_KEY, JSON.stringify(b));

const TONES = [
  { cell: 'bg-emerald-50 text-emerald-900', bar: 'bg-emerald-500', edge: 'border-t-emerald-500' },
  { cell: 'bg-lime-50 text-lime-900', bar: 'bg-lime-500', edge: 'border-t-lime-500' },
  { cell: 'bg-yellow-50 text-yellow-900', bar: 'bg-yellow-400', edge: 'border-t-yellow-400' },
  { cell: 'bg-amber-50 text-amber-900', bar: 'bg-amber-500', edge: 'border-t-amber-500' },
  { cell: 'bg-orange-50 text-orange-900', bar: 'bg-orange-500', edge: 'border-t-orange-500' },
  { cell: 'bg-orange-100 text-orange-950', bar: 'bg-orange-600', edge: 'border-t-orange-600' },
  { cell: 'bg-red-50 text-red-900', bar: 'bg-red-500', edge: 'border-t-red-500' },
  { cell: 'bg-red-100 text-red-950', bar: 'bg-red-700', edge: 'border-t-red-700' },
];

export const tone = (i, n) => {
  if (i < 0) return { cell: 'bg-stone-100 text-stone-700', bar: 'bg-stone-400', edge: 'border-t-stone-400' };
  const r = n <= 1 ? 0 : i / (n - 1);
  return TONES[Math.round(r * (TONES.length - 1))];
};

export const fmtQty = (v) => (Number(v) || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 });

export const fmtDate = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? String(iso).slice(0, 10)
    : d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
};

export const STORAGE_TABS = [
  { id: 'greige', label: 'Greige Storage', hint: 'Bundles in Greige Storage locations' },
  { id: 'sfg', label: 'SFG Storage', hint: 'Bundles stored in SFG bins' },
  { id: 'fg', label: 'FG Storage', hint: 'Pieces stored in FG bins' },
];

// Query params shared by /items and /export for the current selection.
export const selectionParams = ({ storage, breaks, search, drill }) => {
  const p = new URLSearchParams({ storage, breaks: breaks.join(',') });
  if (search) p.append('search', search);
  if (drill?.bucket !== null && drill?.bucket !== undefined) p.append('bucket', String(drill.bucket));
  if (drill?.group) {
    p.append('grouped', 'true');
    Object.entries(drill.group.filter || {}).forEach(([k, v]) => p.append(k, v || ''));
  }
  return p;
};

export const startExcelDownload = (params) => {
  params.append('site_id', localStorage.getItem('active_site_id') || 'salem');
  const tok = localStorage.getItem('session_token');
  if (tok) params.append('token', tok);
  const a = document.createElement('a');
  a.href = `${process.env.REACT_APP_BACKEND_URL}/api/storage-ageing/export?${params.toString()}`;
  a.target = '_blank';
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
};
